import { z } from "zod";

// Schemas

export const PhoneNumberSchema = z.object({
  type: z.string(),
  number: z.string(),
});
